import React, { useEffect } from "react";
import { generateClient } from "@aws-amplify/api";
import {
  Collection,
  Card,
  Heading,
  View,
  Flex,
  Badge,
  Divider,
} from "@aws-amplify/ui-react";
import { useRouter } from "next/router";
// GraphQL imports
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Order, ModelSortDirection } from "../src/API";
import { ordersByEmailAndCreatedAt } from "../src/graphql/queries";

function OrderComponent({ email }) {
  const router = useRouter();
  const client = generateClient();
  const [data, setData] = React.useState<Order[]>();
  const [loaded, setLoaded] = React.useState<boolean>(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    async function fetchOrderData() {
      const request = (await client.graphql({
        query: ordersByEmailAndCreatedAt,
        variables: {
          email,
          sortDirection: ModelSortDirection.DESC,
        },
      })) as {
        data: { ordersByEmailAndCreatedAt: { items: Order[] } };
        errors: unknown[];
      };
      // console.log(request.data.ordersByEmailAndCreatedAt.items);
      setData(request.data.ordersByEmailAndCreatedAt.items);
      setLoaded(true);
    }
    fetchOrderData();
  }, [client, email, router]);

  return (
    <>
      {loaded && (
        <Collection
          items={data}
          type="grid"
          templateColumns={isSmallScreen ? "1fr" : "1fr 1fr"}
          gap="20px"
        >
          {(item, index) => (
            <Card key={index} borderRadius="medium" variation="outlined">
              <View padding="xs">
                <Flex>
                  <Badge
                    key={item.fulfillment_status}
                    backgroundColor={
                      item.fulfillment_status === "Delivered"
                        ? "green.40"
                        : item.fulfillment_status === "Shipped"
                          ? "yellow.40"
                          : "neutral.40"
                    }
                  >
                    {item.fulfillment_status}
                  </Badge>
                </Flex>
                <Divider padding="xs" />
                <Heading paddingTop="medium">
                  <div className="flex flex-col justify-between text-sm sm:text-lg">
                    Invoice #: {item.invoiceNumber}
                    <br />
                    Date:{" "}
                    {new Date(item.createdAt).toLocaleDateString(undefined, {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                    {/* <div className="flex justify-center items-center py-4">
                      <button
                        type="button"
                        className="bg-black text-white py-3 px-6 rounded-full border-black border"
                        onClick={redirectToReceipt}
                      >
                        Receipt
                      </button>
                    </div> */}
                  </div>
                </Heading>
              </View>
            </Card>
          )}
        </Collection>
      )}
    </>
  );
}

export default OrderComponent;
